import { useState } from 'react'

import type { Option } from '@segment/matcha/components/Menu/useMenu'

interface FiltersProps {
  [key: string]: Option[]
}

const useFilters = () => {
  const [filters, setFilters] = useState<FiltersProps>({})

  const updateFilters = (index: string, options: Option[]) => {
    setFilters((prevState) => ({
      ...prevState,
      [index]: options,
    }))
  }

  const filtersString = Object.entries(filters)
    .map(([name, value]) =>
      value.length
        ? `${name}:"${value.map((el, index) => `${index > 0 ? ` OR ${name}:"` : ``}${el.value}"`).join(``)}`
        : undefined
    )
    .filter(Boolean)
    .join(` AND `)

  return {
    updateFilters,
    filtersString,
  }
}

export default useFilters
